export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_02.99419fd6.jpg";